<template>
    <div>
        <!-- <div id="cnCdStock" style="width: 100%;height:calc(100vh - 84px);overflow-x: auto;"> -->
            <div style="display: flex; width: 100%; justify-content: space-between; flex-wrap: nowrap;background-color: #fff;">
                <vxe-form v-bind="formOptions" style="flex-wrap: wrap;overflow-x: hidden;  " size="mini">
                </vxe-form>
                <vxe-toolbar ref="toolbarRef" custom>
                </vxe-toolbar>
            </div>
            <div style="height:calc(100vh - 140px)">
                <vxe-table id="driverInfo" :data="tableData" border :column-config="{ resizable: true }" class="table-style" size="mini"
                    :columns="columns" stripe width="100%" height="auto" :custom-config="customConfig" 
                    ref="tableRef" :row-config="{ isCurrent: true /* 启用当前行高亮 */  }">
                    <vxe-column type="seq" width="50" align="center"></vxe-column>
                    <vxe-column v-for="(column, index) in columns" :field="column.field" :title="column.title"
                        align="center">
                        <template #default="{ row, column }">
                            <vxe-switch v-if="column.field === 'status'" v-model="row.status"
                                @change="handleSwitchChange(row)">
                            </vxe-switch>
                            <span v-if="column.field !== 'status'"> {{ row[column.field] }} </span>
                        </template>
                    </vxe-column>
                    <vxe-column title="操作" width="250" align="center">
                        <template #default="{ row }">
                            <vxe-button mode="text" status="success" icon="vxe-icon-edit"
                                @click="editEvent(row)">编辑</vxe-button>
                            <!-- <vxe-button mode="text" status="warning" icon="vxe-icon-user-fill"
                                @click="exchangeEvent(row)">更换司机</vxe-button> -->
                        </template>
                    </vxe-column>
                </vxe-table>
            </div>
            
            <el-dialog :title="isAddEdit === 2 ? '编辑' : '新增'" :visible.sync="showEditPopup" width="60%" :before-close="cancelEvent"
            v-dialogDrag>
                <el-form ref="formReftruk" :model="formReftruk" label-width="80px" :rules="rulestruk">
                    <el-form-item label="车牌号" prop="vehicleNum">  
                        <el-input v-model="formReftruk.vehicleNum" placeholder="请输入车牌号"></el-input>
                    </el-form-item>
                    <el-form-item label="车架号" prop="vnNum">  
                        <el-input v-model="formReftruk.vnNum" placeholder="请输入车架号"></el-input>
                    </el-form-item>
                    <el-form-item label="司机姓名" prop="driver">  
                        <el-select v-model="formReftruk.driver" placeholder="请选择" style="width: 100%;">
                            <el-option v-for="item in driverNameOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="所属公司" prop="company">  
                        <el-select v-model="formReftruk.company" placeholder="请选择所属公司" style="width: 100%;">
                            <el-option v-for="item in companyOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="cancelEvent">取 消</el-button>
                    <el-button type="primary" @click="confirmEvent">确 定</el-button>
                </span>
            </el-dialog>
        <!-- </div> -->
    </div>
</template>

<script>
import { VxeUI } from 'vxe-pc-ui'
import XEUtils from 'xe-utils'
// 表格自适应
import userProfile from '@/mixins/userProfile.js'
import { options } from 'less'
export default {
    name: 'truckInfo',
    mixins: [userProfile],
    data() {
        const formOptions = {
            data: {
                vehicleNum: '',
            },
            items: [
                { field: 'vehicleNum', title: '车辆查询', span: 12, itemRender: { name: 'VxeInput' } },
                {
                    span: 3,
                    align: 'center',
                    itemRender: {
                        name: 'VxeButtonGroup',
                        options: [
                            { type: 'submit', content: '搜索', status: 'primary', name: 'search', style: 'min-width: 80px' },
                            { type: 'reset', content: '重置', name: 'reset', style: 'min-width: 80px' },
                            { type: 'submit', content: '添加车辆信息', status: 'success', name: 'obtainInventory', style: 'min-width: 80px' },
                        ],
                        events: {
                            click: this.handleButtonClick // 调用 methods 中的方法
                        }
                    }
                }
            ]
        }
        return {
            formReftruk:{
                vehicleNum:'',
                vnNum:'',
                driver:'',
                company:'',
            },
            driverNameOptions:[],
            showDriverPopup: false,
            tableData: [],
            columns: [],
            formOptions,
            showEditPopup: false,
            isAddEdit: null,
            companyOptions:[],
            rulestruk:{
                vehicleNum: [
                    { required: true, message: '请输入车牌号', trigger: 'blur' }
                ],
                vnNum: [
                    { required: true, message: '请输入车架号', trigger: 'blur' }
                ],
                // driver: [
                //     { required: true, message: '请选择司机', trigger: 'blur' }
                // ],
                company: [
                    { required: true, message: '请选择所属公司', trigger: 'blur' }
                ],
            },
        }
    },
        //组件创建
    mounted() {
        this.loadTableData();
        this.getDriverNameOptions();
        this.getCompanyNameOptions();
    },
    methods: {
        getDriverNameOptions() {
            this.$api.getDriverByName( '' ).then(res =>{
                this.driverNameOptions = res.tableData.map(element => {
                    return {
                        label: element.driverName,
                        value: element.driverName
                    };
                });
            })
        },
        // 查询所属公司
        getCompanyNameOptions(){
            this.$api.getDicList( { value:'车辆组织机构'} ).then(res =>{
                    this.companyOptions = res.map(element => {
                        return {
                            label: element.value,
                            value: element.value
                        };
                    });
                })
        },
        //开关切换
        handleSwitchChange(row) {
            this.$api.changeStatusBaseInfo( row.id ).then(res =>{
                this.$message({
                    type: "success",
                    message: '切换成功'
                });
            })
        },
        handleButtonClick(options, button) {
            switch (button.name) {
                case 'search':
                    this.loadTableData();
                    break;
                case 'reset':
                    this.resetEvent();
                    break;
                case 'obtainInventory':
                    this.obtainInventory();
                    break;
            }
        },
        obtainInventory() {
            //判断新增
            this.isAddEdit = 1;
            this.formReftruk = {
                vehicleNum:'',
                vnNum:'',
                driver:'',
                company:'',
            }
            this.showEditPopup = true;
        },
        editEvent(row) {
            this.isAddEdit = 2;
            this.showEditPopup = true;
            this.formReftruk.vehicleNum = row.vehicleNum
            this.formReftruk.vnNum = row.vnNum
            this.formReftruk.driver = row.driver
            this.formReftruk.company = row.company
            this.formReftruk.id = row.id
        },
        cancelEvent() {
            this.$nextTick(()=>{
                this.$refs.formReftruk.resetFields();
            })
            this.showEditPopup = false;
        },
        async confirmEvent() {
            this.$refs.formReftruk.validate((valid) => {
                if (valid) {
                    this.$api.insOrUpdateVehicle( this.formReftruk ).then(res =>{
                        this.$message({
                            type: "success",
                            message: this.isAddEdit == 1?'新增成功' : '修改成功'
                        });
                        this.showEditPopup = false
                        this.loadTableData()
                    })
                } else {
                    return false;
                }
            });
        },
        // 重置
        resetEvent() {
            this.formOptions.data.vehicleNum = '';
        },
        // 加载表格数据和列配置
        loadTableData() {
            this.$api.getInfosByName( { info:this.formOptions.data.vehicleNum } ).then(res =>{
                this.columns = res.columns; // 动态列配置
                this.tableData = res.tableData; // 表格数据
            })
        },
    }
}
</script>

<style lang="css" scoped>
::v-deep .table-style .vxe-table .vxe-cell {
    padding: 0 !important;
    line-height: 1.3vh;
}

::v-deep .el-form-item__label-wrap {
    margin-left: 0px !important;
}

::v-deep .table-style .vxe-body--column {
    padding: 0 !important;
}

::v-deep .form-style .vxe-form--item-title {
    width: 120px !important;
}

::v-deep .vxe-button {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 60px;
    /* padding:0 2px !important; */
}

</style>